import React from 'react';

export default function SessionListPanel({ sessions, t }) {
  if (!sessions || sessions.length === 0) {
    return (
      <div className="modal-section sessions-breakdown">
        <h3>📋 {t('Session History')}</h3>
        <p className="no-data-message">{t('No sessions recorded yet.')}</p>
      </div>
    );
  }

  return (
    <div className="modal-section sessions-breakdown">
      <h3>📋 {t('Session-by-Session Breakdown')}</h3>
      <div className="sessions-table-container">
        <table className="sessions-table">
          <thead>
            <tr>
              <th>{t('Date')}</th>
              <th>{t('Emotion')}</th>
              <th>{t('Motivation')}</th>
              <th>{t('Burnout')}</th>
              <th>{t('Engagement')}</th>
              <th>{t('Stress')}</th>
              <th>{t('Wellbeing')}</th>
            </tr>
          </thead>
          <tbody>
            {sessions.slice(0, 10).map((session, index) => {
              const sessionKey = session.session_id || `session-${index}-${session.session_date || 'unknown'}`;

              const emotionScore = session.emotion_score !== null && session.emotion_score !== undefined
                ? parseFloat(session.emotion_score) : null;
              const motivationScore = session.motivation_score !== null && session.motivation_score !== undefined
                ? parseFloat(session.motivation_score) : null;
              const burnoutScore = session.burnout_score !== null && session.burnout_score !== undefined
                ? parseFloat(session.burnout_score) : null;
              const engagementScore = session.engagement_score !== null && session.engagement_score !== undefined
                ? parseFloat(session.engagement_score) : null;
              const stressScore = session.stress_score !== null && session.stress_score !== undefined
                ? parseFloat(session.stress_score) : null;
              const wellbeingScore = session.wellbeing_score !== null && session.wellbeing_score !== undefined
                ? parseFloat(session.wellbeing_score) : null;

              return (
                <tr key={sessionKey}>
                  <td>
                    {session.session_date ? new Date(session.session_date).toLocaleDateString() : 'N/A'}
                  </td>
                  <td className={`score-cell ${emotionScore === null ? 'no-data' : emotionScore < 30 ? 'low' : emotionScore > 70 ? 'high' : 'medium'}`}>
                    {emotionScore !== null ? emotionScore.toFixed(1) : 'N/A'}
                  </td>
                  <td className={`score-cell ${motivationScore === null ? 'no-data' : motivationScore < 30 ? 'low' : motivationScore > 70 ? 'high' : 'medium'}`}>
                    {motivationScore !== null ? motivationScore.toFixed(1) : 'N/A'}
                  </td>
                  <td className={`score-cell ${burnoutScore === null ? 'no-data' : burnoutScore > 70 ? 'high' : burnoutScore > 50 ? 'medium' : 'low'}`}>
                    {burnoutScore !== null ? burnoutScore.toFixed(1) : 'N/A'}
                  </td>
                  <td className={`score-cell ${engagementScore === null ? 'no-data' : engagementScore < 50 ? 'low' : engagementScore > 70 ? 'high' : 'medium'}`}>
                    {engagementScore !== null ? engagementScore.toFixed(1) : 'N/A'}
                  </td>
                  <td className={`score-cell ${stressScore === null ? 'no-data' : stressScore > 75 ? 'high' : stressScore > 50 ? 'medium' : 'low'}`}>
                    {stressScore !== null ? stressScore.toFixed(1) : 'N/A'}
                  </td>
                  <td className={`score-cell ${wellbeingScore === null ? 'no-data' : wellbeingScore < 50 ? 'low' : wellbeingScore > 70 ? 'high' : 'medium'}`}>
                    {wellbeingScore !== null ? wellbeingScore.toFixed(1) : 'N/A'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
